import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';

import { updateWorkoutInfo } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
} from '~/components/Dialog/styles';
import Loading from '~/components/Loading';

export default function EditWorkoutDialog({
  isOpen,
  setIsOpen,
  workout,
  refreshWorkouts,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      await updateWorkoutInfo(workout.id, values);
      toast.success('Ficha alterada com sucesso !');

      refreshWorkouts();
    } catch (error) {
      toast.error('Ops, não foi possivel alterar esta ficha!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  const getUpdatableFields = () => {
    const { name, observations } = workout;
    return { name, observations };
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>Alterar ficha</SDialogTitle>
      <Formik
        enableReinitialize
        initialValues={getUpdatableFields()}
        onSubmit={handleSubmit}
      >
        <Form>
          <div>
            <Field
              name="name"
              label="Nome da ficha"
              required
              {...defaultFieldProps}
            />
            <Field
              name="observations"
              label="Observações"
              {...defaultFieldProps}
            />
          </div>

          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Alterar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

EditWorkoutDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  workout: PropTypes.object.isRequired,
  refreshWorkouts: PropTypes.func.isRequired,
};
